import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const indexPage = resolve => require(["../page/index/index.vue"], resolve);
const soultion = resolve => require(["../page/soultion/soultion.vue"], resolve);
const aboutus = resolve => require(["../page/aboutus/aboutus.vue"], resolve);
const buildPlan = resolve =>
    require(["../page/buildPlan/buildPlan.vue"], resolve);
const customCase = resolve =>
    require(["../page/customCase/customCase.vue"], resolve);
const contactUs = resolve =>
    require(["../page/contactUs/contactUs.vue"], resolve);

const help = resolve => require(["../page/help/help.vue"], resolve);
const newGuide = resolve => require(["../page/help/newGuide.vue"], resolve);
const shareholderUseFlow = resolve =>
    require(["../page/help/shareholderUseFlow.vue"], resolve);
const findShopkeeper = resolve =>
    require(["../page/help/shareholderUseFlow/findShopkeeper.vue"], resolve);
const addShopkeeper = resolve =>
    require(["../page/help/shareholderUseFlow/addShopkeeper.vue"], resolve);
const setBonus = resolve =>
    require(["../page/help/shareholderUseFlow/setBonus.vue"], resolve);
const developResource = resolve =>
    require(["../page/help/shareholderUseFlow/developResource.vue"], resolve);
const consumeInShop = resolve =>
    require(["../page/help/shareholderUseFlow/consumeInShop.vue"], resolve);
const getBonus = resolve =>
    require(["../page/help/shareholderUseFlow/getBonus.vue"], resolve);
const drawCash = resolve =>
    require(["../page/help/shareholderUseFlow/drawCash.vue"], resolve);
const defendShopkeeper = resolve =>
    require(["../page/help/shareholderUseFlow/defendShopkeeper.vue"], resolve);
const shareholderRewardScheme = resolve =>
    require(["../page/help/shareholderRewardScheme.vue"], resolve);
const staffRewardUseFlow = resolve =>
    require(["../page/help/staffRewardUseFlow.vue"], resolve);
const getCustomersUseFlow = resolve =>
    require(["../page/help/getCustomersUseFlow.vue"], resolve);
const addTicket = resolve =>
    require(["../page/help/getCustomersUseFlow/addTicket.vue"], resolve);
const sendTicket = resolve =>
    require(["../page/help/getCustomersUseFlow/sendTicket.vue"], resolve);
const shareTicket = resolve =>
    require(["../page/help/getCustomersUseFlow/shareTicket.vue"], resolve);
const consumeReduce = resolve =>
    require(["../page/help/getCustomersUseFlow/consumeReduce.vue"], resolve);
const getRepay = resolve =>
    require(["../page/help/getCustomersUseFlow/getRepay.vue"], resolve);
const activityEffect = resolve =>
    require(["../page/help/getCustomersUseFlow/activityEffect.vue"], resolve);
const videoIndex = resolve => require(["../page/video/video.vue"], resolve);

export default new Router({
    routes: [
        //首页
        {
            path: "/",
            name: "indexPage",
            component: indexPage
        },
        //解决方案
        {
            path: "/soultion",
            name: "soultion",
            component: soultion
        },
        //关于我们
        {
            path: "/aboutus",
            name: "aboutus",
            component: aboutus
        },
        //建站方案
        {
            path: "/buildPlan",
            name: "buildPlan",
            component: buildPlan
        },
        //客户案例
        {
            path: "/customCase",
            name: "customCase",
            component: customCase
        },
        //联系我们
        {
            path: "/contactUs",
            name: "contactUs",
            component: contactUs
        },
        //帮助
        {
            path: "/help",
            name: "help",
            component: help
        },
        //新手指引
        {
            path: "/help/newGuide",
            name: "newGuide",
            component: newGuide
        },
        //超级会员使用流程
        {
            path: "/help/shareholderUseFlow",
            name: "shareholderUseFlow",
            component: shareholderUseFlow
        },
        // 找超级会员
        {
            path: "/help/shareholderUseFlow/findShopkeeper",
            name: "FindShopkeeper",
            component: findShopkeeper
        },
        // 添加超级会员
        {
            path: "/help/shareholderUseFlow/addShopkeeper",
            name: "AddShopkeeper",
            component: addShopkeeper
        },
        // 设置奖励
        {
            path: "/help/shareholderUseFlow/setBonus",
            name: "SetBonus",
            component: setBonus
        },
        // 发展资源
        {
            path: "/help/shareholderUseFlow/developResource",
            name: "DevelopResource",
            component: developResource
        },
        // 到店消费
        {
            path: "/help/shareholderUseFlow/consumeInShop",
            name: "ConsumeInShop",
            component: consumeInShop
        },
        // 获取奖励
        {
            path: "/help/shareholderUseFlow/getBonus",
            name: "GetBonus",
            component: getBonus
        },
        // 超级会员提现
        {
            path: "/help/shareholderUseFlow/drawCash",
            name: "DrawCash",
            component: drawCash
        },
        // 维护超级会员
        {
            path: "/help/shareholderUseFlow/defendShopkeeper",
            name: "DefendShopkeeper",
            component: defendShopkeeper
        },
        //超级会员奖励方案
        {
            path: "/help/shareholderRewardScheme",
            name: "shareholderRewardScheme",
            component: shareholderRewardScheme
        },
        //员工分红使用流程
        {
            path: "/help/staffRewardUseFlow",
            name: "staffRewardUseFlow",
            component: staffRewardUseFlow
        },
        //超级获客模式说明
        {
            path: "/help/getCustomersUseFlow",
            name: "getCustomersUseFlow",
            component: getCustomersUseFlow
        },
        // 新增积客券
        {
            path: "/help/getCustomersUseFlow/addTicket",
            name: "AddTicket",
            component: addTicket
        },
        // 发送积客券
        {
            path: "/help/getCustomersUseFlow/sendTicket",
            name: "SendTicket",
            component: sendTicket
        },
        // 分享积客券
        {
            path: "/help/getCustomersUseFlow/shareTicket",
            name: "ShareTicket",
            component: shareTicket
        },
        // 领券客户消费抵用
        {
            path: "/help/getCustomersUseFlow/consumeReduce",
            name: "ConsumeReduce",
            component: consumeReduce
        },
        // 分享客户获得返还
        {
            path: "/help/getCustomersUseFlow/getRepay",
            name: "GetRepay",
            component: getRepay
        },
        // 店铺统计活动效果
        {
            path: "/help/getCustomersUseFlow/activityEffect",
            name: "ActivityEffect",
            component: activityEffect
        },
        //视频教程-内容
        {
            path: "/video/:id",
            name: "video",
            component: videoIndex
        },

        //视频教程-首页
        {
            path: "/video",
            name: "video",
            component: videoIndex
        },
        //视频教程app-内容
        {
            path: "/appvideo/:id",
            name: "video",
            component: videoIndex
        },

        //视频教程app-首页
        {
            path: "/appvideo",
            name: "video",
            component: videoIndex
        }
    ]
});


// WEBPACK FOOTER //
// ./src/router/index.js